export enum eAuthority {
    City = 'city',
    County = 'county',
    State = 'state',
    Local = 'local',
  }
  